import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { FaXmark, FaX } from "react-icons/fa6";

import SectionHeader from "../../components/SectionHeader";

import { useDispatch, useSelector } from "react-redux";
import {
  removeFromCart,
  fetchCartItems,
  addToCart,
  updateCart,
} from "../../store2/features/cartSlice";
import Thumbimg from "../../assets/images/courses/course_thumb01.jpg";
import RenderRazorpay from "./RenderRazorpay";
import Loader from "../../features/Loader";
import ApiService from "../../services/ApiService";
import { callAlert } from "../../services/CommonService";
import { paymentDetails } from "../../services/AuthService";
import { FaCheck } from "react-icons/fa6";
import Title from "../../components/Title/Title";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import CourseSlider from "../../components/CourseSlider";
import PageLoader from "../../features/PageLoader";

export default function CartPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cart = useSelector((state) => state.cart.items);
  const { courses } = useSelector((state) => state.courses);
  // const { loaderStatus } = useSelector((state) => state.courses.loaderStatus);
  const loading = useSelector((state) => state.cart.loading);
  const basePrice = useSelector((state) => state.cart.cartPrice);
  const [cartPrice, setCartPrice] = useState();

  const [cgst, setCgst] = useState();
  const [igst, setIgst] = useState();
  const [cartTotal, setCartTotal] = useState();

  const [cartDiscount, setCartDiscount] = useState();

  const cartCount = useSelector((state) => state.cart.cartItems);

  const [cartItems, setCartItems] = useState(cart);
  const [userDetails, setUserDetails] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState(false);
  const [promocode, setPromocode] = useState("");
  const [promoStatus, setPromoStatus] = useState({
    type: "",
    message: "",
  });

  const recommendedRef = useRef(null);

  useEffect(() => {
    if (!cartCount || cartCount.length === 0) {
      // wait a little so UI renders first
      setTimeout(() => {
        recommendedRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 200);
    }
  }, [cartCount]);

  // const [loaderStatus, setLoaderStatus] = useState(true);
  // const [Course, setCourse] = useState([]);

  // const getCartArr = () => {
  //     // Save cart data to local storage
  //     let cart = localStorage.getItem('cartItems');
  //     setCartItems(JSON.parse(cart));
  // };

  useEffect(() => {
    console.log("000000000");
    setCartPrice(basePrice);
    setCgst(basePrice ? basePrice * 0.09 : 0);
    setIgst(basePrice ? basePrice * 0.18 : 0);
    setCartTotal(basePrice ? basePrice + basePrice * 0.18 : 0);
  }, [basePrice]); // set the relation between redux campaign and local state

  const handleCheckout = () => {
    // Save cart data to local storage
    if (isChecked) {
      let cartIds = cartItems.map((cart) => cart.cartId);
      // handleCreateOrder(100, cartIds)
      const taxedPrice = cartTotal;
      handleCreateOrder(taxedPrice, cartIds);
    } else {
      setError(true);
    }
  };
  useEffect(() => {
    dispatch(fetchCartItems());
    console.log("Cart count" + cartCount);
  }, [dispatch]);

  const handleRemoveFromCart = (cartId) => {
    if (cartId) {
      console.log(`Removing cart item with id: ${cartId}`);
      dispatch(removeFromCart(cartId));
    } else {
      console.error("cartId is null or undefined:", cartId);
    }
    cancelPromoCode();
  };

  useEffect(() => {
    setCartItems(cart);
    const userDetailss = localStorage.getItem("userDetails");

    // const timeoutId = setTimeout(() => {
    //   setCartItems(cart);
    // }, 20);

    // if (cart.cartResponseWOList && cart.cartResponseWOList.length == 0) {
    //     // getCartArr();
    // }
    if (userDetailss) {
      setUserDetails(JSON.parse(userDetailss));
      // dispatch(initializeCart());
    }
    // return () => clearTimeout(timeoutId);
  }, [cart]);

  // console.log(cart, "Cart------------------------------------------------------------------")

  // const getTotalPrice = () => {
  //     let total = 0;
  //     if (cartItems.cartResponseWOList && cartItems.cartResponseWOList.length > 0) {
  //         cartItems.cartResponseWOList.forEach((item) => {
  //             total += parseFloat(item?.course && item?.course.price);
  //         });
  //     }
  //     return total.toFixed(2); // Fixed here
  // };

  /*  ------------------------------ payment gateway ------------------------------ */
  const [displayRazorpay, setDisplayRazorpay] = useState(false);
  const [orderDetails, setOrderDetails] = useState({
    orderId: null,
    currency: null,
    amount: null,
    // name: null,
  });

  const cancelPromoCode = () => {
    setPromoStatus({
      type: "",
      message: "",
    });
    setCartPrice(basePrice);
    setCartTotal(basePrice ? basePrice + basePrice * 0.18 : 0);
    setIgst(basePrice ? basePrice * 0.18 : 0);
    setCgst(basePrice ? basePrice * 0.09 : 0);

    setCartDiscount("");
    setPromocode("");
  };
  const submitPromoCode = () => {
    if (!promocode) {
      setPromoStatus({
        type: "error",
        message: "Please a valid coupon code.",
      });

      return;
    }
    setPromoStatus({
      type: "",
      message: "",
    });

    ApiService.paymentPostRequest(`/coupon-service/validate`, {
      cartValue: +basePrice,
      code: promocode,
    })
      .then((res) => {
        if (res.data?.resultCode === 1) {
          let response = res.data.data;

          setPromoStatus({
            type: "success",
            message: "Coupon code has been applied successfully.",
          });

          if (response.percentage && response.percentage > 0) {
            let maxDiscount = response.maxDiscount;
            let percentage = response.percentage;
            let discount = (basePrice * percentage) / 100;
            if (discount > maxDiscount) {
              discount = maxDiscount;
            }

            setCartDiscount(discount);
            let newPrice = parseInt(basePrice) - parseInt(discount);
            setCartPrice(newPrice);
            setCgst(newPrice ? newPrice * 0.09 : 0);
            // setIgst(basePrice ? basePrice * 0.18 : 0);
            setIgst(newPrice ? newPrice * 0.18 : 0);
            setCartTotal(newPrice ? newPrice + newPrice * 0.18 : 0);
          } else {
            setCartDiscount(res.data.data.discount);
            let newPrice =
              parseInt(basePrice) - parseInt(res.data.data.discount);
            setCartPrice(newPrice);
            setCgst(newPrice ? newPrice * 0.09 : 0);
            setIgst(basePrice ? basePrice * 0.18 : 0);
            setCartTotal(newPrice ? newPrice + newPrice * 0.18 : 0);
          }
        } else {
          setPromoStatus({
            type: "error",
            message: res.data?.message,
          });
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
      });
  };
  const handleCreateOrder = async (amount, cartId) => {
    let currency = "INR";
    const data1 = {
      keySecret: "qSAFIlVf4ykhHVJYUTZantu4",
      keyId: "rzp_live_WqTNlHMlup5dHH",
      //rzp_test_t4QiH1ERSLyefk OufgiiVRWTweWVW8dm2pY5qe
    };
    setLoader(true);

    ApiService.paymentPostRequest("/payment/create-order", {
      amount: amount * 100,
      currency: currency,
      // email: "infomahendra2009@gmail.com",
      cartId: cartId,
      mobile: "8802225536",
    })
      .then((response) => {
        if (response?.data?.data) {
          setLoader(false);

          let data = response?.data;

          if (data.data && data.data.orderId) {
            setOrderDetails({
              //name: "mahendra1",
              orderId: data.data.orderId,
              currency: currency,
              amount: data.data.amount,
              keyId: data1.keyId,
              keySecret: data1.keySecret,
            });
            setDisplayRazorpay(true);
          }
        } else {
          setLoader(false);
          callAlert("", response?.data?.message);
        }
      })
      .catch((error) => {
        setLoader(false);
        callAlert(error?.error?.message);
      });
  };
  /*  payment gateway ------------------------------ */

  const handleRemoveModule = (cartId, courseId, moduleId) => {
    cartItems.map((item) => {
      if (item.course.courseId === courseId) {
        const updatedModuleList = item.course.moduleList
          .filter((module) => module.id !== moduleId)
          .map((module) => module.id);
        dispatch(
          updateCart({
            cartId: cartId,
            courseId: courseId,
            moduleList: updatedModuleList,
          }),
        ).then(() => dispatch(fetchCartItems()));
        // window.location.reload();
      }
    });
    cancelPromoCode();
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await ApiService.publicGetRequest(
  //         "/courses/findallcourses",
  //       );
  //       setLoaderStatus(false);
  //       setCourse(response.data.data);
  //     } catch (error) {
  //       console.error("Error fetching courses:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  return (
    cartItems && (
      <>
        <Title
          options={{ title: "Cart", description: "", image: "", url: "" }}
        />
        <div className=" sectionWrapper cart-wrapper">
          <div className="container mt-2 mb-5">
            {/* {cartItems.cartResponseWOList && cartItems.cartResponseWOList.length === 0 ? ( */}
            {cartItems && cartItems.length === 0 && !loading ?
              <>
                <div className="col-md-6">
                  <SectionHeader className="">
                    <span className="subtitle">Cart</span>
                    <h2 className="title">
                      Your <span>Cart</span>{" "}
                    </h2>
                  </SectionHeader>
                </div>
                <div className="d-flex justify-content-center align-items-center vh-30 mb-6">
                  <div className="text-center">
                    <p className="display-6 fw-bold">No items in cart</p>
                  </div>
                </div>
              </>
            : <>
                {loading && <PageLoader />}
                {!loading && (
                  <>
                    <div className="container mb-5">
                      <div className="row ">
                        <div className="col-md-8">
                          <div className="card border shadow-0">
                            <div className="m-4">
                              <SectionHeader className="">
                                <h2 className="title mb-3">Your Cart</h2>
                              </SectionHeader>
                              <hr />
                              {/* <h4 className="card-title mb-4">Your selected courses</h4> */}
                              {/* {cartItems.cartResponseWOList && cartItems.cartResponseWOList.map((item, index) => ( */}
                              {cartItems &&
                                cartItems.map((item, index) => (
                                  <div key={index} className="mb-3">
                                    <div className="row gy-3 mb-4">
                                      <div className="col-md-7">
                                        <div className="d-flex">
                                          {item?.course && item?.course.image && item?.course.board !== "Other" ?
                                          
                                            <Link
                                              to={`/course-details/${item?.course?.courseId}`}
                                            >
                                              <img
                                                src={item?.course.image}
                                                className="border rounded me-3"
                                                style={{
                                                  width: "96px",
                                                  height: "96px",
                                                }}
                                                alt="Item 1"
                                              />
                                            </Link>
                                          : <Link
                                              to={`/other-course-details/${item?.course?.courseId}`}
                                            >
                                              <img
                                                className="border rounded me-3"
                                                src={Thumbimg}
                                                alt="img"
                                                style={{
                                                  width: "100px",
                                                  height: "70px",
                                                }}
                                              />
                                            </Link>
                                          }
                                          <div className="">
                                            <Link
                                              to={`/course-details/${item?.course?.courseId}`}
                                              className="nav-link fw-bold fs-4"
                                            >
                                              {item?.course &&
                                                item?.course.courseName}
                                            </Link>
                                            {/* <p className="text-muted">{item.board}</p> */}
                                            <h5 className="nav-link fw-italic ">
                                              Modules:{" "}
                                              {item?.course?.moduleList.length}
                                            </h5>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-md-5 d-flex justify-content-end">
                                        <div className="float-md-end">
                                          <span className="price mt-2 me-5">
                                            {item?.course && (
                                              <>₹{item?.totalPrice}</>
                                            )}
                                          </span>
                                          {/* <a href="#!" className="btn btn-light border px-2 icon-hover-primary">Icon</a> */}
                                          <button
                                            className="btn btn-outline-danger"
                                            onClick={() =>
                                              handleRemoveFromCart(item?.cartId)
                                            }
                                          >
                                            <FaXmark /> Remove
                                          </button>
                                          {/* <a href="#" className="btn btn-light border text-danger icon-hover-danger"> Remove</a> */}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-md-12">
                                        <table className="table table-bordered table-striped f12">
                                          <thead>
                                            <tr>
                                              <th className="col-md-1">
                                                Selected
                                              </th>
                                              <th>Module Name</th>
                                              {item?.course?.discount &&
                                                item?.totalPrice <
                                                  item.course.discount && (
                                                  <th>Price</th>
                                                )}

                                              {/* <th>Price</th> */}
                                              <th className="col-md-1">
                                                Remove
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item?.course?.moduleList.map(
                                              (module, index) => (
                                                <tr key={index}>
                                                  <td className="text-center">
                                                    {/* <input type="checkbox" checked={true} readOnly className="form-check-input" /> */}
                                                    <FaCheck />
                                                  </td>
                                                  <td>{module.name}</td>

                                                  {(
                                                    item?.totalPrice <
                                                    item?.course.discount
                                                  ) ?
                                                    <td>
                                                      {"₹" + module.price}
                                                      {/* {"₹" + module.price} */}
                                                    </td>
                                                  : <></>}
                                                  <td
                                                    className="text-center"
                                                    onClick={() =>
                                                      handleRemoveModule(
                                                        item.cartId,
                                                        item.course.courseId,
                                                        module.id,
                                                      )
                                                    }
                                                  >
                                                    <button className="btn btn-danger">
                                                      <FaX />
                                                    </button>
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                            {/* {console.log(item, "item--------------------------------")} */}

                                            {/* <tr>
                                                                            <td>  AJAX Development</td>
                                                                            <td>Rs. 15,000</td>
                                                                            <td className="text-center">    <input type="checkbox" checked readOnly className="form-check-input" /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>  AJAX Development 2</td>
                                                                            <td>Rs. 15,000</td>
                                                                            <td className="text-center">    <input type="checkbox" checked readOnly className="form-check-input" /> </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>  AJAX Development 3</td>
                                                                            <td>Rs. 15,000</td>
                                                                            <td className="text-center">    <input type="checkbox" checked readOnly className="form-check-input" /> </td>
                                                                        </tr> */}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </div>

                            {/* Delivery and summary */}
                            {/* <div className="border-top pt-4 mx-4 mb-4">
                                                <p><i className="fas fa-truck text-muted fa-lg"></i> Instructions</p>
                                                <p className="text-muted">
                                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                                </p>
                                            </div> */}
                          </div>
                        </div>

                        <div className="col-md-4">
                          {/* <div className="card mb-3 border shadow-0">
                                                <div className="card-body">
                                                    <form>
                                                        <div className="form-group">
                                                            <label className="form-label">Have coupon?</label>
                                                            <div className="input-group">
                                                                <input type="text" className="form-control border" name="" placeholder="Coupon code" />
                                                                <button className="btn btn-light border">Apply</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div> */}
                          <div className="card shadow-0 border">
                            <div className="card-body">
                              <SectionHeader className="">
                                <h2 className="title mb-3">
                                  Cart <span>Summary</span>
                                </h2>
                              </SectionHeader>
                              <hr />

                              <div className="d-flex justify-content-between">
                                <p className="mb-1">Base Price</p>

                                {/* <h5 className="price">₹{cartItems.cartResponseWOList[0].totalPrice}</h5> */}
                                {/* <h5 className="price">₹{cartItems && cartItems.cartPrice}</h5> */}
                                <h5 className="">
                                  ₹ {basePrice ? basePrice.toFixed(2) : ""}
                                </h5>
                                {/* <p className="mb-2">${getTotalPrice()}</p> */}
                              </div>
                              {cartDiscount && (
                                <>
                                  <div className="d-flex justify-content-between f12">
                                    <p className="mb-2 text-success">
                                      {" "}
                                      Discount{" "}
                                    </p>
                                    <h5 className="  text-success">
                                      {" "}
                                      - ₹{cartDiscount.toFixed(2)}{" "}
                                    </h5>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <p className="mb-1">New Base Price</p>
                                    <h5 className="">
                                      ₹ {cartPrice ? cartPrice.toFixed(2) : ""}
                                    </h5>
                                  </div>
                                </>
                              )}

                              {userDetails.stateId == "UK" && (
                                <>
                                  <div className="d-flex justify-content-between ">
                                    <p className="mb-1 f12">SGST (9%) </p>
                                    {/* <h5 className="price">₹{cartItems.cartResponseWOList[0].totalPrice}</h5> */}
                                    {/* <h5 className="price">₹{cartItems && cartItems.cartPrice}</h5> */}
                                    <h5 className="f12">
                                      + ₹ {cgst ? cgst.toFixed(2) : ""}
                                    </h5>
                                    {/* <p className="mb-2">${getTotalPrice()}</p> */}
                                  </div>
                                  <div className="d-flex justify-content-between  ">
                                    <p className="mb-2 f12">CGST (9%) </p>
                                    {/* <h5 className="price">₹{cartItems.cartResponseWOList[0].totalPrice}</h5> */}
                                    {/* <h5 className="price">₹{cartItems && cartItems.cartPrice}</h5> */}
                                    <h5 className="f12">
                                      + ₹ {cgst ? cgst.toFixed(2) : ""}
                                    </h5>
                                    {/* <p className="mb-2">${getTotalPrice()}</p> */}
                                  </div>{" "}
                                </>
                              )}

                              {userDetails.stateId != "UK" && (
                                <>
                                  <div className="d-flex justify-content-between  ">
                                    <p className="mb-2 f12">IGST (18%) </p>
                                    <h5 className="f12">
                                      + ₹ {igst ? igst.toFixed(2) : ""}
                                    </h5>
                                  </div>
                                </>
                              )}

                              <hr />
                              <div className="d-flex justify-content-between">
                                <p className="mb-2">You Pay :</p>
                                <h5 className="price">
                                  {" "}
                                  ₹{cartTotal ? cartTotal.toFixed(2) : ""}{" "}
                                </h5>
                              </div>

                              <hr />
                              <div className="">
                                <p className="mb-2">
                                  {" "}
                                  <strong>Coupon Code:</strong> <br />
                                  {!cartDiscount && (
                                    <div class="row g-3 align-items-center">
                                      <div class="col-auto">
                                        <input
                                          type="text"
                                          placeholder="Enter coupon code"
                                          className="form-control"
                                          value={promocode}
                                          style={{
                                            "min-width": "auto",
                                            width: "165px",
                                            height: "36px",
                                            "font-size": "12px",
                                          }}
                                          onChange={(ev) => {
                                            setPromocode(ev.target.value);
                                          }}
                                        />
                                      </div>{" "}
                                      <div class="col-auto">
                                        <button
                                          className="btn btn-success btn-sm"
                                          onClick={submitPromoCode}
                                        >
                                          Apply{" "}
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                  {cartDiscount && (
                                    <div class="row g-3 align-items-center">
                                      <div class="col-auto">
                                        <input
                                          type="text"
                                          className="form-control "
                                          value={promocode}
                                          disabled
                                          style={{
                                            "min-width": "auto",
                                            width: "165px",
                                            height: "36px",
                                            "font-size": "16px",
                                            background: "#eaedeb",
                                          }}
                                        />
                                      </div>{" "}
                                      <div class="col-auto">
                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={cancelPromoCode}
                                        >
                                          x{" "}
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                  {promoStatus.type == "error" && (
                                    <p className="text-danger text-left mt-2 f12">
                                      {promoStatus.message}
                                    </p>
                                  )}
                                  {promoStatus.type == "success" && (
                                    <p className="text-success text-left  mt-2 f12">
                                      {promoStatus.message}
                                    </p>
                                  )}
                                </p>
                              </div>

                              <hr />
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="flexCheckDefault"
                                  checked={isChecked}
                                  onChange={(event) =>
                                    setIsChecked(event.target.checked)
                                  }
                                />
                                <Link
                                  to="/terms-and-conditions"
                                  target="_blank"
                                >
                                  <p className="text-primary">
                                    Terms & Conditions
                                  </p>
                                </Link>
                                {error ?
                                  <div className="text-danger f12">
                                    Please accept terms & conditions
                                  </div>
                                : <></>}
                              </div>
                              <div className="mt-3">
                                {userDetails && (
                                  <button
                                    type="button"
                                    disabled={loader}
                                    className="btn btn-primary w-100 shadow-0 mb-2"
                                    onClick={handleCheckout}
                                  >
                                    {loader && (
                                      <span className="spinner-border spinner-border-sm"></span>
                                    )}{" "}
                                    Make Purchase{" "}
                                  </button>
                                )}

                                {!userDetails && (
                                  <button
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#loginModal"
                                    className="btn btn-primary w-100 shadow-0 mb-2"
                                  >
                                    {" "}
                                    Login to checkout{" "}
                                  </button>
                                )}

                                <Link
                                  to="/"
                                  className="btn btn-light w-100 border mt-2"
                                >
                                  {" "}
                                  Back to Home{" "}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            }
          </div>

          {displayRazorpay && (
            <RenderRazorpay
              amount={orderDetails.amount}
              currency={orderDetails.currency}
              orderId={orderDetails.orderId}
              keyId={orderDetails.keyId}
              keySecret={orderDetails.keySecret}
            />
          )}
        </div>

        {/* {!loaderStatus && ( */}
        {!loading && (
          <>
            <div
              className="sectionWrapper mylearning-wrapper"
              ref={recommendedRef}
            >
              <Container>
                <Row>
                  <Col sm={12}>
                    <div className="content-box p-3">
                      {/* <h2 className="title">Course to get your start</h2> */}

                      <div className="tabs-wrapper">
                        <Tabs
                          defaultActiveKey="recommended"
                          transition={false}
                          id="noanim-tab-example"
                          className="mb-3"
                        >
                          {cartItems && cartItems.length > 0 ?
                            <Tab
                              eventKey="recommended"
                              title="Explore our courses below!"
                            >
                              {<CourseSlider dataCourse={courses} />}
                            </Tab>
                          : <Tab
                              eventKey="recommended"
                              title="Your cart is empty. Explore our recommended courses below!"
                            >
                              {<CourseSlider dataCourse={courses} />}
                            </Tab>
                          }
                          {/* <Tab eventKey="mostpopular" title="Most Popular">
                            {<CourseSlider dataCourse={Course} />}
                          </Tab> */}
                        </Tabs>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </>
        )}
      </>
    )
  );
}
